/**
 * Shared searchable breed combobox — bird-data.json via SC_loadSpeciesList.
 * Top field is the search input; dropdown portals to document.body.
 */
(function () {
  if (window.__SC_BREED_COMBOBOX_INIT__) return;
  window.__SC_BREED_COMBOBOX_INIT__ = true;

  var _speciesPromise = null;
  var LS_MANUAL_KEY = 'sc_species_breed_manual';
  var ATTR_SOURCE = '_species_source';
  var ATTR_PRIMARY = 'species_breed';
  var ATTR_SECONDARY = 'species_breed2';
  var CART_COMBOBOX_ID = 'CartSpeciesBreedCombobox';

  function loadSpeciesList() {
    if (_speciesPromise) return _speciesPromise;
    var url = window.SC_BREED_DATA_URL;
    if (!url) {
      console.error('[SC Breed Combobox] SC_BREED_DATA_URL is not set');
      return Promise.resolve([]);
    }
    _speciesPromise = fetch(url, { cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('species load failed');
        return res.json();
      })
      .then(function (data) {
        var speciesObj = data.species || data || {};
        return Object.keys(speciesObj)
          .map(function (s) { return (s || '').toLowerCase().trim(); })
          .filter(Boolean)
          .sort();
      })
      .catch(function (err) {
        console.error('[SC Breed Combobox]', err);
        return [];
      });
    return _speciesPromise;
  }

  window.SC_loadSpeciesList = loadSpeciesList;

  function normalizeBreedKey(val) {
    return (val || '').toLowerCase().trim();
  }

  function capitalize(s) {
    if (!s) return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function isManualBreedLocked() {
    try {
      if (localStorage.getItem(LS_MANUAL_KEY) === 'true') return true;
    } catch (e) {}
    return false;
  }

  function setManualBreedLocked(locked) {
    try {
      if (locked) localStorage.setItem(LS_MANUAL_KEY, 'true');
      else localStorage.removeItem(LS_MANUAL_KEY);
    } catch (e) {}
  }

  function updateCartAttribute(key, value) {
    if (window.SC_debouncedUpdateAttribute && window.SC_isDebouncedAttrKey && window.SC_isDebouncedAttrKey(key)) {
      return window.SC_debouncedUpdateAttribute(key, value);
    }
    if (!window.theme || !theme.cart || !theme.cart.updateAttribute) {
      return Promise.resolve();
    }
    return theme.cart.updateAttribute(key, value).catch(function (err) {
      console.error('[SC Breed Combobox] attribute persist failed', err);
    });
  }

  function getCartBreedState() {
    var state = {
      species_breed: '',
      species_breed2: '',
      manualLocked: isManualBreedLocked()
    };

    if (!window.theme || !theme.cart || !theme.cart.getCart) {
      try {
        var lsPrimary = normalizeBreedKey(localStorage.getItem(ATTR_PRIMARY));
        var lsSecondary = normalizeBreedKey(localStorage.getItem(ATTR_SECONDARY));
        if (lsPrimary) state.species_breed = lsPrimary;
        if (lsSecondary) state.species_breed2 = lsSecondary;
      } catch (e) {}
      return Promise.resolve(state);
    }

    return theme.cart.getCart().then(function (cart) {
      var attrs = cart.attributes || {};
      if (attrs[ATTR_PRIMARY]) {
        state.species_breed = normalizeBreedKey(attrs[ATTR_PRIMARY]);
      }
      if (attrs[ATTR_SECONDARY]) {
        state.species_breed2 = normalizeBreedKey(attrs[ATTR_SECONDARY]);
      }
      state.manualLocked = isManualBreedLocked() || attrs[ATTR_SOURCE] === 'manual';

      if (!state.species_breed) {
        var hidden = document.querySelector('#CartSpeciesBreed[data-sc-breed-value], #CartSpeciesBreed');
        if (hidden && hidden.value) {
          state.species_breed = normalizeBreedKey(hidden.value);
        }
      }

      if (!state.species_breed) {
        try {
          var lsHero = normalizeBreedKey(localStorage.getItem(ATTR_PRIMARY));
          if (lsHero) state.species_breed = lsHero;
        } catch (e) {}
      }

      if (!state.species_breed2) {
        try {
          var lsAlt = normalizeBreedKey(localStorage.getItem(ATTR_SECONDARY));
          if (lsAlt) state.species_breed2 = lsAlt;
        } catch (e) {}
      }

      return state;
    }).catch(function () {
      return state;
    });
  }

  function syncCartComboboxUI(key, options) {
    options = options || {};
    var root = document.getElementById(CART_COMBOBOX_ID);
    if (!root) return;

    var hidden = root.querySelector('[data-sc-breed-value]');
    var input = root.querySelector('[data-sc-breed-input]');
    var normalized = normalizeBreedKey(key);
    if (!normalized) return;

    if (hidden) {
      hidden.value = normalized;
      hidden.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (input) {
      input.value = capitalize(normalized);
      input.classList.remove('is-placeholder');
    }

    if (options.persist !== false && root.dataset.persist === 'cart-attribute') {
      updateCartAttribute(root.dataset.attributeKey || ATTR_PRIMARY, normalized);
    }
  }

  function clearSecondaryBreed() {
    try { localStorage.removeItem(ATTR_SECONDARY); } catch (e) {}
    return updateCartAttribute(ATTR_SECONDARY, '');
  }

  function handleManualBreedSelection(key) {
    var normalized = normalizeBreedKey(key);
    if (!normalized) return Promise.resolve();

    setManualBreedLocked(true);
    try { localStorage.setItem(ATTR_PRIMARY, normalized); } catch (e) {}

    var updates = [
      updateCartAttribute(ATTR_SOURCE, 'manual'),
      updateCartAttribute(ATTR_PRIMARY, normalized)
    ];

    var secondary = normalizeBreedKey(localStorage.getItem(ATTR_SECONDARY));
    var row2 = document.querySelector('#CartDrawer [data-sc-bird="2"]');
    var hasBird2 = !!(row2 && !row2.hidden);
    if (secondary && secondary === normalized && !hasBird2) {
      updates.push(clearSecondaryBreed());
    }

    return Promise.all(updates);
  }

  function tryPrefillFromFinder(root, speciesList, state) {
    if (!root || root.dataset.persist !== 'cart-attribute') return Promise.resolve();
    if ((root.dataset.attributeKey || ATTR_PRIMARY) !== ATTR_PRIMARY) return Promise.resolve();
    if (isManualBreedLocked()) return Promise.resolve();

    state = state || {};
    if (state.manualLocked || state.species_breed) return Promise.resolve();

    var finderPrimary = normalizeBreedKey(localStorage.getItem(ATTR_PRIMARY));
    if (!finderPrimary || speciesList.indexOf(finderPrimary) === -1) return Promise.resolve();

    root.__scBreedSelected = finderPrimary;
    syncCartComboboxUI(finderPrimary, { persist: true });
    return Promise.resolve();
  }

  window.SC_routeFinderBreed = function (searchedKey) {
    var key = normalizeBreedKey(searchedKey);
    if (!key) return Promise.resolve(null);

    return loadSpeciesList().then(function (list) {
      if (list.indexOf(key) === -1) return null;

      return getCartBreedState().then(function (state) {
        var primary = state.species_breed;
        var manualLocked = state.manualLocked;
        var identifyPayload = null;
        var updates = [];

        if (manualLocked) {
          if (key !== primary) {
            try { localStorage.setItem(ATTR_SECONDARY, key); } catch (e) {}
            updates.push(updateCartAttribute(ATTR_SECONDARY, key));
            identifyPayload = { species_breed2: key };
          }
        } else if (!primary) {
          try { localStorage.setItem(ATTR_PRIMARY, key); } catch (e) {}
          setManualBreedLocked(false);
          updates.push(
            updateCartAttribute(ATTR_SOURCE, 'finder'),
            updateCartAttribute(ATTR_PRIMARY, key)
          );
          identifyPayload = { species_breed: key };
          syncCartComboboxUI(key, { persist: false });
        } else if (key !== primary) {
          try { localStorage.setItem(ATTR_SECONDARY, key); } catch (e) {}
          updates.push(updateCartAttribute(ATTR_SECONDARY, key));
          identifyPayload = { species_breed2: key };
        }

        return Promise.all(updates).then(function () {
          if (identifyPayload && window._learnq) {
            window._learnq.push(['identify', identifyPayload]);
          }
          return identifyPayload;
        });
      });
    });
  };

  function initCombobox(root) {
    if (!root || root.dataset.scBreedInit === 'true') return;
    root.dataset.scBreedInit = 'true';

    var hidden = root.querySelector('[data-sc-breed-value]');
    var input = root.querySelector('[data-sc-breed-input]');
    var listbox = root.querySelector('[data-sc-breed-listbox]');
    var dropdown = root.querySelector('[data-sc-breed-dropdown]');
    var dropdownHome = dropdown ? dropdown.parentNode : null;
    var placeholder = (input && input.getAttribute('placeholder')) || 'Search breeds...';

    var speciesList = null;
    var selected = (hidden && hidden.value || root.getAttribute('data-initial-value') || '').toLowerCase().trim();
    root.__scBreedSelected = selected;
    /* 21 Oct 2026: values set from outside (SC_setBreedComboboxValue, the Bird Finder, the quiz) change the hidden field and fire
       'change'. Keep this closure's 'selected' in step, or the next click anywhere puts the old breed back in the box. */
    if (hidden) {
      hidden.addEventListener('change', function () {
        var v = normalizeBreedKey(hidden.value);
        if (v !== selected) { selected = v; root.__scBreedSelected = v; }
      });
    }
    var activeIndex = -1;
    var filtered = [];
    var loaded = false;
    var blurTimer = null;
    var userEdited = false;

    function persistValue(val, isManual) {
      if (root.dataset.persist !== 'cart-attribute') return;
      var ownKey = root.dataset.attributeKey || ATTR_PRIMARY;
      if (ownKey !== ATTR_PRIMARY) {
        if (ownKey === ATTR_SECONDARY) {
          try { localStorage.setItem(ATTR_SECONDARY, val); } catch (e) {}
        }
        updateCartAttribute(ownKey, val);
        return;
      }
      if (isManual) {
        handleManualBreedSelection(val);
        return;
      }
      updateCartAttribute(root.dataset.attributeKey || ATTR_PRIMARY, val);
    }

    function setInputDisplay(val) {
      if (!input) return;
      if (!val) {
        input.value = '';
        input.classList.add('is-placeholder');
        return;
      }
      input.value = capitalize(val);
      input.classList.remove('is-placeholder');
    }

    function revertInput() {
      if (selected && speciesList && speciesList.indexOf(selected) !== -1) {
        setInputDisplay(selected);
        return;
      }
      setInputDisplay('');
    }

    function commit(val, isManual) {
      if (!val || !speciesList || speciesList.indexOf(val) === -1) return false;
      selected = val;
      root.__scBreedSelected = val;
      userEdited = false;
      if (hidden) {
        hidden.value = val;
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      }
      setInputDisplay(val);
      persistValue(val, isManual === true);
      closeDropdown();
      return true;
    }

    function portalDropdown() {
      if (!dropdown || dropdown.parentNode === document.body) return;
      document.body.appendChild(dropdown);
    }

    function restoreDropdown() {
      if (!dropdown || !dropdownHome || dropdown.parentNode === dropdownHome) return;
      dropdownHome.appendChild(dropdown);
    }

    function positionDropdown() {
      if (!input || !dropdown) return;
      var r = input.getBoundingClientRect();
      dropdown.style.position = 'fixed';
      dropdown.style.top = Math.round(r.bottom) + 'px';
      dropdown.style.left = Math.round(r.left) + 'px';
      dropdown.style.width = Math.round(r.width) + 'px';
      dropdown.style.zIndex = '10050';
    }

    function renderOptions(filter) {
      if (!listbox || !speciesList) return;
      var q = (filter || '').toLowerCase().trim();
      filtered = speciesList.filter(function (s) { return s.indexOf(q) !== -1; });
      activeIndex = -1;
      listbox.innerHTML = '';

      if (!filtered.length) {
        var empty = document.createElement('div');
        empty.className = 'sc-breed-combobox__empty';
        empty.textContent = 'No breeds found';
        listbox.appendChild(empty);
        return;
      }

      filtered.forEach(function (s, idx) {
        var opt = document.createElement('div');
        opt.className = 'sc-breed-combobox__option' + (s === selected ? ' is-selected' : '');
        opt.id = root.id + '-opt-' + idx;
        opt.setAttribute('role', 'option');
        opt.dataset.val = s;
        opt.textContent = capitalize(s);
        listbox.appendChild(opt);
      });

      input.removeAttribute('aria-activedescendant');
    }

    function setActiveIndex(idx) {
      if (!listbox) return;
      var opts = listbox.querySelectorAll('.sc-breed-combobox__option');
      if (!opts.length) return;
      if (activeIndex < 0) {
        activeIndex = 0;
      } else {
        activeIndex = Math.max(0, Math.min(idx, opts.length - 1));
      }
      opts.forEach(function (el, i) {
        el.classList.toggle('is-active', i === activeIndex);
      });
      input.setAttribute('aria-activedescendant', opts[activeIndex].id);
      opts[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    function openDropdown() {
      if (!dropdown || !input) return;
      loadIfNeeded().then(function () {
        portalDropdown();
        dropdown.hidden = false;
        dropdown.removeAttribute('hidden');
        input.setAttribute('aria-expanded', 'true');
        input.classList.add('is-open');
        positionDropdown();
        renderOptions(input.value);
      });
    }

    function closeDropdown() {
      if (!dropdown || !input) return;
      dropdown.hidden = true;
      dropdown.setAttribute('hidden', '');
      input.setAttribute('aria-expanded', 'false');
      input.classList.remove('is-open');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
      restoreDropdown();
    }

    function applyHeroPrefill(state) {
      if (selected && speciesList && speciesList.indexOf(selected) !== -1) {
        if (hidden) hidden.value = selected;
        setInputDisplay(selected);
        return;
      }

      var heroKey = (root.dataset.attributeKey || ATTR_PRIMARY) === ATTR_SECONDARY ? 'species_breed2' : 'species_breed';
      if (state && state[heroKey] && !state.manualLocked) {
        var hero = normalizeBreedKey(state[heroKey]);
        if (hero && speciesList.indexOf(hero) !== -1) {
          selected = hero;
          root.__scBreedSelected = hero;
          if (hidden) hidden.value = hero;
          setInputDisplay(hero);
          return;
        }
      }

      if (!selected && root.__scBreedSelected) {
        selected = root.__scBreedSelected;
        if (hidden) hidden.value = selected;
        setInputDisplay(selected);
      }
    }

    function loadIfNeeded() {
      if (loaded && speciesList) return Promise.resolve(speciesList);
      return loadSpeciesList().then(function (list) {
        speciesList = list;
        loaded = true;
        root.dispatchEvent(new CustomEvent('sc-breed-combobox-ready', {
          bubbles: true,
          detail: { root: root, id: root.id }
        }));

        return getCartBreedState().then(function (state) {
          applyHeroPrefill(state);
          return tryPrefillFromFinder(root, speciesList, state).then(function () {
            if (!selected && root.__scBreedSelected) {
              selected = root.__scBreedSelected;
              if (hidden) hidden.value = selected;
              setInputDisplay(selected);
            }
            return speciesList;
          });
        });
      });
    }

    function handleDocumentClick(e) {
      if (root.contains(e.target)) return;
      if (dropdown && dropdown.contains(e.target)) return;
      closeDropdown();
      revertInput();
    }

    if (input) {
      input.addEventListener('focus', function () {
        loadIfNeeded().then(function () {
          openDropdown();
        });
      });

      input.addEventListener('input', function (e) {
        userEdited = true;
        input.classList.remove('is-placeholder');
        if (dropdown && dropdown.hidden) openDropdown();
        else renderOptions(e.target.value);
      });

      input.addEventListener('keydown', function (e) {
        var opts = listbox ? listbox.querySelectorAll('.sc-breed-combobox__option') : [];
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (dropdown && dropdown.hidden) openDropdown();
          else setActiveIndex(activeIndex + 1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          setActiveIndex(activeIndex <= 0 ? 0 : activeIndex - 1);
        } else if (e.key === 'Enter') {
          e.preventDefault();
          if (activeIndex >= 0 && opts[activeIndex]) {
            commit(opts[activeIndex].dataset.val, true);
          } else {
            var typed = input.value.toLowerCase().trim();
            if (typed && speciesList && speciesList.indexOf(typed) !== -1) {
              commit(typed, true);
            } else {
              revertInput();
              closeDropdown();
            }
          }
        } else if (e.key === 'Escape') {
          e.preventDefault();
          revertInput();
          closeDropdown();
        }
      });

      input.addEventListener('blur', function () {
        clearTimeout(blurTimer);
        blurTimer = setTimeout(function () {
          if (dropdown && dropdown.contains(document.activeElement)) return;
          var typed = input.value.toLowerCase().trim();
          if (userEdited && typed && speciesList && speciesList.indexOf(typed) !== -1) {
            commit(typed, true);
            return;
          }
          revertInput();
          closeDropdown();
        }, 200);
      });
    }

    if (listbox) {
      listbox.addEventListener('mousedown', function (e) {
        e.preventDefault();
      });
      listbox.addEventListener('click', function (e) {
        var node = e.target.closest('.sc-breed-combobox__option');
        if (!node) return;
        e.stopPropagation();
        userEdited = true;
        commit(node.dataset.val || '', true);
        input.focus();
      });
    }

    document.addEventListener('click', handleDocumentClick);

    window.addEventListener('scroll', function () {
      if (dropdown && !dropdown.hidden) positionDropdown();
    }, true);

    window.addEventListener('resize', function () {
      if (dropdown && !dropdown.hidden) positionDropdown();
    });

    loadIfNeeded();
  }

  window.SC_initBreedComboboxes = function (scope) {
    var ctx = scope || document;
    ctx.querySelectorAll('[data-sc-breed-combobox]').forEach(initCombobox);
  };

  window.SC_setBreedComboboxValue = function (rootOrId, val, options) {
    options = options || {};
    var root = typeof rootOrId === 'string' ? document.getElementById(rootOrId) : rootOrId;
    if (!root) return;
    var hidden = root.querySelector('[data-sc-breed-value]');
    var input = root.querySelector('[data-sc-breed-input]');
    var normalized = normalizeBreedKey(val);
    loadSpeciesList().then(function (list) {
      if (list.indexOf(normalized) === -1) return;
      if (hidden) {
        hidden.value = normalized;
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (input) {
        input.value = capitalize(normalized);
        input.classList.remove('is-placeholder');
      }
      root.__scBreedSelected = normalized;
      if (root.dataset.persist === 'cart-attribute') {
        if (options.manual) {
          handleManualBreedSelection(normalized);
        } else if (options.persist !== false) {
          updateCartAttribute(root.dataset.attributeKey || ATTR_PRIMARY, normalized);
        }
      }
    });
  };


  /* ---------- Two-bird cart rows (r49, 29 Oct 2026) ----------
     Bird 1: bird_name + species_breed. Bird 2: bird_name2 + species_breed2. Row 2 shows only when the cart holds a
     second bird or the shopper taps "Add another bird". Names save as they type (debounced through sc-cart-queue). */
  var NAME_IDS = { CartBirdName: 'bird_name', CartBirdName2: 'bird_name2' };

  function birdsBox() {
    return document.querySelector('#CartDrawer [data-sc-birds]');
  }

  function setBirdTwo(on, focusName) {
    var box = birdsBox();
    if (!box) return;
    var row = box.querySelector('[data-sc-bird="2"]');
    var add = box.querySelector('[data-sc-bird-add]');
    var rem = box.querySelector('[data-sc-bird-remove]');
    box.classList.toggle('is-two', !!on);
    if (row) row.hidden = !on;
    if (add) add.hidden = !!on;
    if (rem) rem.hidden = !on;
    if (on && focusName) {
      var f = document.getElementById('CartBirdName2');
      if (f) f.focus();
    }
  }

  function setNameValue(id, val) {
    var el = document.getElementById(id);
    if (el && el !== document.activeElement && typeof val === 'string') el.value = val;
  }

  function clearCombobox(root) {
    if (!root) return;
    var hidden = root.querySelector('[data-sc-breed-value]');
    var input = root.querySelector('[data-sc-breed-input]');
    if (hidden) {
      hidden.value = '';
      hidden.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (input) {
      input.value = '';
      input.classList.add('is-placeholder');
    }
    root.__scBreedSelected = '';
  }

  function saveName(key, val) {
    val = String(val || '').trim().slice(0, 40);
    if (window.SC_debouncedUpdateAttribute) return window.SC_debouncedUpdateAttribute(key, val);
    return updateCartAttribute(key, val);
  }

  /* Called by the Bird Match Quiz with each bird's own name and species. n1/n2 null = leave the name as it is. */
  window.SC_setCartBirds = function (d) {
    d = d || {};
    if (typeof d.n1 === 'string' && d.n1) setNameValue('CartBirdName', d.n1);
    if (typeof d.n2 === 'string') setNameValue('CartBirdName2', d.n2);
    if (d.s1 && document.getElementById('CartSpeciesBreedCombobox')) {
      window.SC_setBreedComboboxValue('CartSpeciesBreedCombobox', d.s1, { persist: false });
    }
    var c2 = document.getElementById('CartSpeciesBreedCombobox2');
    if (d.s2 && c2) window.SC_setBreedComboboxValue(c2, d.s2, { persist: false });
    else if (c2 && d.s2 === '') clearCombobox(c2);
    var n2 = typeof d.n2 === 'string' ? d.n2 : ((document.getElementById('CartBirdName2') || {}).value || '');
    setBirdTwo(!!(n2 || d.s2));
  };

  function removeBirdTwo() {
    var n2 = document.getElementById('CartBirdName2');
    if (n2) n2.value = '';
    clearCombobox(document.getElementById('CartSpeciesBreedCombobox2'));
    try { localStorage.removeItem(ATTR_SECONDARY); } catch (e) {}
    saveName('bird_name2', '');
    updateCartAttribute(ATTR_SECONDARY, '');
    setBirdTwo(false);
    var add = document.querySelector('#CartDrawer [data-sc-bird-add]');
    if (add) add.focus();
  }

  function syncBirdTwoFromCart() {
    var box = birdsBox();
    if (!box || box.classList.contains('is-two')) return;
    var cart = window.SC_getLastCart && window.SC_getLastCart(15000);
    var a = cart && cart.attributes;
    if (!a) return;
    var n2 = String(a.bird_name2 || '').trim();
    var s2 = normalizeBreedKey(a[ATTR_SECONDARY]);
    if (!n2 && !s2) return;
    if (n2) setNameValue('CartBirdName2', n2);
    if (s2 && document.getElementById('CartSpeciesBreedCombobox2')) {
      window.SC_setBreedComboboxValue('CartSpeciesBreedCombobox2', s2, { persist: false });
    }
    setBirdTwo(true);
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-sc-bird-add],[data-sc-bird-remove]') : null;
    if (!t || !t.closest('#CartDrawer')) return;
    e.preventDefault();
    if (t.hasAttribute('data-sc-bird-add')) setBirdTwo(true, true);
    else removeBirdTwo();
  });

  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.id || !NAME_IDS[el.id] || !el.closest('#CartDrawer')) return;
    saveName(NAME_IDS[el.id], el.value);
  });

  document.addEventListener('cart:updated', function () { setTimeout(syncBirdTwoFromCart, 0); });
  document.addEventListener('cart:open', function () { setTimeout(syncBirdTwoFromCart, 150); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.SC_initBreedComboboxes();
    });
  } else {
    window.SC_initBreedComboboxes();
  }

  document.addEventListener('cart:open', function () {
    setTimeout(function () {
      var drawer = document.getElementById('CartDrawer');
      if (drawer) window.SC_initBreedComboboxes(drawer);
    }, 100);
  });
})();
